import React from 'react';
import SMSearchFormBaseView from './SMSearchFormBaseView';
import SMAppHelper from 'components/helpers/SMAppHelper';

class SMSearchListFormView extends SMSearchFormBaseView {

  constructor(props) {
    super(props);
  }

  toggleFilter(e) {
    e.preventDefault();
    if(this.props.delegate && typeof this.props.delegate.toggleFilter === 'function'){
      this.props.delegate.toggleFilter(e);
    }
  }

  render() {
    if (SMAppHelper.isMobile()) return null;
    let responsiveClass={};
    switch (this.state.priceType) {
      case 'hourly':
        responsiveClass = {
          area: 'col-xs-9 col-sm-9 col-md-2',
          priceType: 'col-xs-2 col-md-1',
          priceRange: 'col-xs-6 col-md-2',
          start: 'col-xs-12 col-sm-2 col-md-1 search-filter__times',
          end: '',
          startHour: 'col-xs-12 col-sm-2 col-md-1 search-filter__times',
          endHour: 'col-xs-12 col-sm-2 col-md-1 search-filter__times',
          capacity: 'col-xs-12 col-sm-2 col-md-1 search-filter__person-num',
          directReservation: 'col-xs-6 col-md-2 search-filter__times',
        };
        break;
      case 'stay':
        responsiveClass = {
          area: 'col-xs-9 col-sm-9 col-md-2',
          priceType: '',
          priceRange: 'col-xs-6 col-md-2',
          start: 'col-xs-6 col-sm-6 col-md-2 search-filter__times',
          end: 'col-xs-6 col-sm-6 col-md-2 search-filter__times',
          capacity: 'col-xs-12 col-sm-12 col-md-1 search-filter__person-num',
          directReservation: 'col-xs-6 col-md-2 search-filter__times',
        };
        break;
      default:
        responsiveClass = {
          area: 'col-xs-9 col-sm-9 col-md-2',
          priceType: 'col-xs-2 col-md-1',
          priceRange: 'col-xs-6 col-md-2',
          start: 'col-xs-6 col-sm-6 col-md-1 search-filter__times',
          end: 'col-xs-6 col-sm-6 col-md-1 search-filter__times',
          capacity: 'col-xs-12 col-sm-12 col-md-1 search-filter__person-num',
          directReservation: 'col-xs-6 col-md-2 search-filter__times',
        };
    }
    return (
      <div className="search-filter-mod search-filter-mod-head sm-hide">
        <div className="search-box">
          <div className="search-box__main">
            <div className="container-fluid">
              <input type="hidden" name="event_type" value={this.props.eventType} />
              {this.renderAreaField(responsiveClass.area)}
              {this.renderPriceTypeSelect(responsiveClass.priceType)}
              {this.renderPriceRange(responsiveClass.priceRange)}
              {this.renderStartedAtField(responsiveClass.start)}
              {this.renderStartedHourField(responsiveClass.startHour)}
              {this.renderEndedAtField(responsiveClass.end)}
              {this.renderEndedHourField(responsiveClass.endHour)}
              {this.renderCapacityRange(responsiveClass.capacity)}
              {this.renderDirectReservationCheckbox(responsiveClass.directReservation)}
              {this.renderFilterButton()}
              {this.renderDatePicker('datetime-layout clearfix date-select-layout')}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default SMSearchListFormView;



// WEBPACK FOOTER //
// ./app/javascript/components/search/SMSearchListFormView.jsx